import script from "./recommend.vue?vue&type=script&setup=true&lang=js"
export * from "./recommend.vue?vue&type=script&setup=true&lang=js"

import "./recommend.vue?vue&type=style&index=0&id=06d6c05a&lang=less&scoped=true"

import exportComponent from "/Users/liuxiong/Documents/美通官网/huanshuntong/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d6c05a"]])

export default __exports__